import { render, staticRenderFns } from "./LogCardMoved.vue?vue&type=template&id=82bd9fd4"
import script from "./LogCardMoved.vue?vue&type=script&lang=js"
export * from "./LogCardMoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports